import CLEResultsAsync from './CLEResultsAsync';

export default CLEResultsAsync;
